import { render, staticRenderFns } from "./permanen.vue?vue&type=template&id=2eec2c4f&scoped=true"
import script from "./permanen.vue?vue&type=script&lang=js"
export * from "./permanen.vue?vue&type=script&lang=js"
import style0 from "./permanen.vue?vue&type=style&index=0&id=2eec2c4f&prod&lang=scss"
import style1 from "./permanen.vue?vue&type=style&index=1&id=2eec2c4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eec2c4f",
  null
  
)

export default component.exports